<template>
  <section class="graph">
    <div class="container container_sec" :class="dayNight">
      <h2>Сокращения Книг / число зачал</h2>
      <table>
        <tr v-for="val in Object.entries(books)" :key="val">
          <td>{{ val[0] }}</td>
          <td :style="val[0] === '' ? 'color: darkred' : ''">
            {{ val[1] }}
          </td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TheGraph',
  props: {
    msg: Object
  },
  data() {
    return {
      books: {
        'Мф.': 'Евангелие от Матфея / 166',
        'Мк.': 'Евангелие от Марка / 71',
        'Лк.': 'Евангелие от Луки / 114',
        'Ин.': 'Евангелие от Иоанна / 67',
        '': 'Апостол содержит 335 зачал',
        'Деян.': 'Деяния свв. Апостолов',
        'Иак.': 'Послание апостола Иакова',
        '1_Пет.': 'Первое послание Петра',
        '2_Пет.': 'Второе послание Петра',
        '1_Ин.': 'Первое послание Иоанна',
        '2_Ин.': 'Второе послание Иоанна',
        '3_Ин.': 'Третье послание Иоанна',
        'Иуд.': 'Послание Иуды',
        'Рим.': 'Послание к Римлянам',
        '1_Кор.': 'Первое послание к Коринфянам',
        '2_Кор.': 'Второе послание к Коринфянам',
        'Гал.': 'Послание к Галатам',
        'Еф.': 'Послание к Ефесянам',
        'Флп.': 'Послание к Филиппийцам',
        'Кол.': 'Послание к Колоссянам',
        '1_Сол.': '1-е послание к Фессалоникийцам',
        '2_Сол.': '2-е послание к Фессалоникийцам',
        '1_Тим.': 'Первое послание к Тимофею',
        '2_Тим.': 'Второе послание к Тимофею',
        'Тит.': 'Послание к Титу',
        'Флм.': 'Послание к Филимону',
        'Евр.': 'Послание к Евреям',
        'Иез.': 'Книга Пророка Иезекииля',
        'Иоил.': 'Книга Пророка Иоиля',
        'Прем._Солом.': 'Книга Премудрости Соломона',
        'Ис.': 'Книга Пророка Иcайи',
        'Исх.': 'Книга Исход',
        'Быт.': 'Книга Бытие',
        'Притч.': 'Книга Притчей Соломоновых',
        'Мал.': 'Книга Пророка Малахии'
      }
    }
  },
  computed: {
    dayNight() {
      return {
        fonday: this.msg.isDay,
        txtDay: this.msg.isDay,
        fonnight: !this.msg.isDay,
        txtNight: !this.msg.isDay
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.graph {
  display: flex;

  h2 {
    font-size: 1.3rem;
    text-align: center;
  }

  table,
  td,
  th {
    border: 1px solid grey;
  }
  table {
    border-collapse: collapse;
    width: 95%;
    margin: 0 auto 1rem;
    font-size: 1.2rem;
  }
  th,
  td {
    text-align: center;
    vertical-align: top;
    // width: 50%;
  }
  tr:first {
    width: 15%;
  }
}

@media screen and (min-width: 576px) {
}

@media screen and (min-width: 767px) {
  h2 {
    font-size: 1.7rem;
  }
}

@media screen and (min-width: 991px) {
}

@media screen and (min-width: 1200px) {
}
</style>
